import React from 'react';
import { useBusinessRules } from '@common/components/Business/rules';
import { Role as InnerField } from '@common/components/BusinessForm/components/Role';
import { FieldWrapper } from '../FieldWrapper';

export default function Role() {
  const { roleRules } = useBusinessRules();
  return (
    <FieldWrapper<string>
      name="role"
      rules={roleRules}
      render={(props) => <InnerField {...props} />}
    />
  );
}
